import { useQuery } from '@tanstack/react-query';

import modifierGateway from './Modifiers.gateway';
import { modifierKeys } from './Modifiers.queryKeys';

export default function useModifierGroups(venueId, filters) {
  return useQuery({
    queryKey: modifierKeys.groups(venueId),
    queryFn: () => modifierGateway.getModifierGroups(venueId, filters),
    enabled: !!venueId,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
}
